import styled from "styled-components";
import { StyledMainContainer as DefaultStyledMainContainer } from "../styles";

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`;

export const StyledMainContainer = styled(DefaultStyledMainContainer)`
  height: 289px;
`;
